import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { Button } from '@/components/button'
import React, { useCallback, useState } from 'react'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import { openErrorDialog } from '@/utils/dialogHelpers'

export function RetryWorkflowButton ({ ticketId, onResume }) {
  const { localize } = useLocalization()
  const isGranted = usePermissionChecker()
  const granted = isGranted('CanResumeWorkflow')
  const [loading, setLoading] = useState(false)
  const handleClick = useCallback(() => {
    setLoading(true)
    context.api.ticketService.resumeWorkflow(ticketId)
      .then(onResume)
      .finally(() => setLoading(false))
      .catch(openErrorDialog)
  }, [onResume, ticketId])
  return granted
    ? (<Button onClick={handleClick} icon={loading ? 'loader bx-spin' : 'revision'} confirmTitle={'Common:Retry'} confirmText={'Common:RetryConfirmation'} disabled={loading}>
      {localize('Common:Retry')}
    </Button>)
    : null
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/retryWorkflowButton.js